/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reached-loadingpoint': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M5.5 6.316c-2.761 0-5 .85-5 1.9 0 1.048 2.239 1.898 5 1.898s5-.85 5-1.899c0-.732-1.091-1.367-2.69-1.684M5.5 8.152V.057M5.563 1.253c2.279 0 1.646 2.785 4.81 2.405C9.613 5.178 7 5.557 5.437 4.924"/></g>'
  }
})
